import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { NavigationService } from 'src/app/services/navigation.service';
import { EventEmitterService } from 'src/app/services/event-emitter.service';
import { EventNavbarService } from 'src/app/services/event-navbar.service';
import { EventYearService } from 'src/app/services/event-year.service';
import { EventYearCalendarService } from 'src/app/services/event-yearCalendar.service';
import { EventMonthService } from 'src/app/services/event-month.service';
import { ContratistasService } from 'src/app/services/contratistas.service';
import { EmpresasService } from 'src/app/services/empresas.service';
import { ZonasService } from 'src/app/services/zonas.service';
import { UserService } from 'src/app/services/user.service';
import { Subject } from 'rxjs';
import { ValidationService } from '../../services/validation.service';
import { LoginService } from '../../services/login.service';
export class CapacitacionesComponent {
    constructor(navigationService, zonasService, contratistasService, empresasService, userService, eventNavbarService, eventYearService, eventMonthService, eventEmitterService, validationService, eventYearCalendarService, loginService) {
        this.navigationService = navigationService;
        this.zonasService = zonasService;
        this.contratistasService = contratistasService;
        this.empresasService = empresasService;
        this.userService = userService;
        this.eventNavbarService = eventNavbarService;
        this.eventYearService = eventYearService;
        this.eventMonthService = eventMonthService;
        this.eventEmitterService = eventEmitterService;
        this.validationService = validationService;
        this.eventYearCalendarService = eventYearCalendarService;
        this.loginService = loginService;
        this.flagBi = false;
        this.flagCapacitaciones = false;
        this.actualView = 'calendar';
        this.filterAno = "";
        this.filterMes = "";
        this.dtTriggerUsuario = new Subject();
        this.confirmationModalHasComment = false;
        this.confirmationModalHasOptions = false;
        this.confirmationModalisCommentObligatory = false;
        this.loadingUsuarios = false;
        this.loadingZonas = false;
        this.message = '';
        this.flagCargaMasiva = false;
        this.isIndicatorsCollapsed = false;
        this.indicatorRealizadas = 'indicator-card';
        this.indicatorPlanificadas = 'indicator-card';
        this.indicatorReforzamiento = 'indicator-card';
        this.showIndicators = false;
        this.visible = false;
        this.year = new Date().getFullYear();
        this.flagRealizadas = false;
        this.flagPlanificadas = false;
        this.flagUsuarios = true;
        this.flagZonas = false;
        this.flagCategorias = false;
        this.flagEnfoques = false;
        this.flagEjecutores = false;
        this.flagFocos = false;
        this.flagRelatores = false;
        this.flagPlanificacion = false;
        this.flagReforzamiento = false;
        this.anioSelected = "";
        this.mesSelected = "";
        this.tipoCapacitacionSelected = "";
        this.page = 0;
        this.pageSize = 50;
        this.loading = false;
        this.month = "";
        this.contratista = "";
        this.empresa = "";
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.loginService.obtenerPermisosMenu('planificacion').then((response) => {
                this.rolid = response.data.rolId;
            });
            $("#show-loading").css('display', 'grid');
            this.rows = [{
                    cells: [{
                            id: 1, zona: "test", empresa: "1", contratista: "Contratista",
                            tipo: "t", nombre: "nombre", categoria: "categoria", foco: "foco",
                            ejecutor: "eje", mes: "1", estado: "abierto"
                        }]
                }];
            this.anioSelected = "0";
            this.mesSelected = "0";
            this.zonaSelected = "0";
            this.tipoCapacitacionSelected = "0";
            this.openNavbar();
            this.flagBi = true;
            this.flagCapacitaciones = true;
            // this.getZonas();
            // console.log(this.zonas);
            // this.getEmpresas();
            // this.getContratistas();
            if (!sessionStorage.getItem('foo')) {
                sessionStorage.setItem('foo', 'no reload');
                // location.reload();
            }
            else {
                sessionStorage.removeItem('foo');
            }
            if (!this.navigationService.getValidLogin()) {
                this.navigationService.goTo('/login');
            }
            $("#show-loading").css('display', 'none');
        });
    }
    changeView(view) {
        this.actualView = view;
        if (this.actualView == 'calendar') {
            this.indicatorRealizadas = 'indicator-card';
            this.indicatorPlanificadas = 'indicator-card';
            this.indicatorReforzamiento = 'indicator-card';
        }
        else {
            this.filterAno = '';
            this.filterMes = '';
        }
    }
    filterMonth(month) {
        this.changeMonth(month);
    }
    filterYear(year) {
        this.changeYear(year);
    }
    filterZone(zone) {
    }
    filterContratista(contratista) {
    }
    filterEnterprise(empresa) {
    }
    getZonas() {
        return new Promise((resolve, reject) => {
            this.zonasService.getZonas()
                .then(response => {
                this.zonas = response;
            })
                .catch(error => reject(error));
        });
    }
    getContratistas() {
        return new Promise((resolve, reject) => {
            this.contratistasService.getContatistas()
                .then(response => {
                this.contratistas = response;
            })
                .catch(error => reject(error));
        });
    }
    getEmpresas() {
        return new Promise((resolve, reject) => {
            this.empresasService.getEmpresas()
                .then(response => {
                this.empresas = response;
            })
                .catch(error => reject(error));
        });
    }
    changeYear(year) {
        this.filterAno = year;
        this.eventYearService.onYearChange(year);
        this.eventYearCalendarService.onYearChange(year);
        this.eventEmitterService.onCalendarRefresh();
    }
    generateArrayOfYears() {
        var max = Number(this.year) + 3;
        var min = max - 6;
        var years = [];
        for (var i = max; i >= min; i--) {
            years.push(i);
        }
        return years;
    }
    changeMonth(month) {
        const months = new Array("Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre");
        this.filterMes = month == '' ? '' : months[parseInt(month) - 1];
        this.eventMonthService.onMonthChange(month == '' ? '' : parseInt(month).toString());
    }
    openNavbar() {
        this.eventNavbarService.openNavbar();
    }
    isIconActiveSend(capacitacion) {
        return this.validationService.isActiveIconSend(capacitacion, String(this.rolid));
    }
    isIconActiveDelete(capacitacion) {
        return this.validationService.isActiveIconDelete(capacitacion, String(this.rolid));
    }
    isIconActiveEdit(capacitacion) {
        return this.validationService.isActiveIconEdit(capacitacion);
    }
    isIconActiveAccept(capacitacion) {
        // return this.validationService.isActiveIconAccept( capacitacion);
        return (this.validationService.canAcceptOrReject(capacitacion, String(this.rolid)) || this.validationService.canClose(capacitacion, String(this.rolid)));
    }
    isIconActiveReject(capacitacion) {
        return this.validationService.isActiveIconReject(capacitacion, String(this.rolid));
    }
}
